import styled from "@emotion/styled";

import { colors } from "shared/config/constants/app.theme";

export const BannerContainer = styled.div`
  width: 100%;
  min-height: 58px;
  background: #E4F6FF;
  color: ${colors.accent[400]};
  border: 1px solid ${colors.accent[400]};
  border-radius: 8px;
  padding: 16px;
  font-size: 15px;
  line-height: 170%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 24px;
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 17.5px;
  flex: 1;
  
  svg {
    width: 21.5px;
    height: 21.5px;
    flex-shrink: 0;
  }
`;

export const BannerMessage = styled.span`
  font-weight: 400;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.accent[400]};
  flex-shrink: 0;
  margin-left: 12px;
  
  &:hover {
    opacity: 0.7;
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

